export const SAVE_USER_STRIPE_INFOS = "SAVE_USER_STRIPE_INFOS";
export const SET_FIRSTNAME_STRIPE_INFOS = "SET_FIRSTNAME_STRIPE_INFOS";
export const SET_LASTNAME_STRIPE_INFOS = "SET_LASTNAME_STRIPE_INFOS";
export const SET_EMAIL_STRIPE_INFOS = "SET_EMAIL_STRIPE_INFOS";
export const SET_TEL_STRIPE_INFOS = "SET_TEL_STRIPE_INFOS";
export const SET_ADDRESS_STRIPE_INFOS = "SET_ADDRESS_STRIPE_INFOS";
export const SET_CITY_STRIPE_INFOS = "SET_CITY_STRIPE_INFOS";
export const SET_POSTAL_CODE_STRIPE_INFOS = "SET_POSTAL_CODE_STRIPE_INFOS";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CHECKOUT = "CHECKOUT";
export const SET_CUSTOMER_ID = "SET_CUSTOMER_ID";
export const CREATE_SOUSCRIPTION = "CREATE_SOUSCRIPTION";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const SET_OFFER_PRICE = "SET_OFFER_PRICE";
export const SET_SUBSCRIPTION_ID = "SET_SUBSCRIPTION_ID";
export const SET_PROMOTION_CODE = "SET_PROMOTION_CODE";
export const CHECK_PROMOTION_CODE = "CHECK_PROMOTION_CODE";
export const SET_PROMOTION_CODE_FLAG = "SET_PROMOTION_CODE_FLAG";
export const SET_ACTIVATION_CODE_FLAG = "SET_ACTIVATION_CODE_FLAG";
export const SET_PROMOTION_CODE_ID = "SET_PROMOTION_CODE_ID";
export const SET_AMOUNT_OFF = "SET_AMOUNT_OFF";
export const SET_PERCENT_OFF = "SET_PERCENT_OFF";

export const saveUserStripeInfos = () => ({
	type: SAVE_USER_STRIPE_INFOS,
});

export const setFirstnameStripeInfos = (firstname) => ({
	type: SET_FIRSTNAME_STRIPE_INFOS,
	firstname
});
export const setLastnameStripeInfos = (lastname) => ({
	type: SET_LASTNAME_STRIPE_INFOS,
	lastname
});
export const setEmailStripeInfos = (email) => ({
	type: SET_EMAIL_STRIPE_INFOS,
	email
});
export const setTelStripeInfos = (tel) => ({
	type: SET_TEL_STRIPE_INFOS,
	tel
});
export const setAddressStripeInfos = (address) => ({
	type: SET_ADDRESS_STRIPE_INFOS,
	address
});
export const setCityStripeInfos = (city) => ({
	type: SET_CITY_STRIPE_INFOS,
	city
});
export const setPostalCodeStripeInfos = (postalCode) => ({
	type: SET_POSTAL_CODE_STRIPE_INFOS,
	postalCode
});

export const createCustomer = () => ({
	type: CREATE_CUSTOMER,
});
export const updateCustomer = () => ({
	type: UPDATE_CUSTOMER,
});

export const setCustomerId = (id) => ({
	type: SET_CUSTOMER_ID,
	id
});

export const createSouscription = () => ({
	type : CREATE_SOUSCRIPTION
});

export const setOfferPrice = (price) => ({
	type: SET_OFFER_PRICE,
	price
});

export const setPromotionCode = (code) => ({
	type: SET_PROMOTION_CODE,
	code
});

export const checkPromotionCode = () => ({
	type : CHECK_PROMOTION_CODE,
});

export const setPromotionCodeFlag = (bool) => ({
	type: SET_PROMOTION_CODE_FLAG,
	bool
});
export const setActivationCodeFlag = (bool) => ({
	type: SET_ACTIVATION_CODE_FLAG,
	bool
});

export const setPromotionCodeId = (id) => ({
	type: SET_PROMOTION_CODE_ID,
	id
});

export const setPercentOff = (percent) => ({
	type: SET_PERCENT_OFF,
	percent
});
export const setAmountOff = (amount) => ({
	type: SET_AMOUNT_OFF,
	amount
});



